import { useState, useContext, useEffect } from 'react';
import { NuevaONGContext } from '../context/NuevaONGContext';
import { Input, Label, Select_simple } from './ui';
import { optionsPartido, optionsCategoria, optionsLPO } from '../datos/options';
import { toast, ToastContainer } from "react-toastify"

const FormularioNuevaONG = ({ ongData, onSave, onCancel }) => {
  const { setNuevaONG } = useContext(NuevaONGContext);
  
  // Estados del formulario
  const [codigo, setCodigo] = useState('');
  const [partidoSede, setPartidoSede] = useState({ value: '', label: '' });
  console.log(partidoSede);
  const [ONG, setONG] = useState('');
  const [resolucion, setResolucion] = useState('');
  const [categoria, setCategoria] = useState('');
  const [agrupacionTerminalPolitica, setAgrupacionTerminalPolitica] = useState('');
  const [referentePolitico, setReferentePolitico] = useState('');
  const [referenteOrganizacion, setReferenteOrganizacion] = useState('');
  const [contacto, setContacto] = useState('');
  const [lpo, setLpo] = useState('');

  //nuevo estado para seleccion multiple
  const [selectedMunicipalityIds, setSelectedMunicipalityIds] = useState([]);

  // Actualizar estados cuando cambia ongData
	useEffect(() => {
		if (ongData) {
			setCodigo(ongData.codigo || '');
			// Si partido_sede es un string, buscar el objeto correspondiente
			if (ongData.partidosede) {
				const partido = optionsPartido.find(p => p.value === ongData.partidosede) ||
					{ value: ongData.partidosede, label: ongData.partido_nombre || ongData.partidosede };
				setPartidoSede(partido);
			} else {
				setPartidoSede({ value: '', label: 'Seleccionar...' });
			}
			setONG(ongData.nombre || '');
			setResolucion(ongData.resolucion || '');
			setCategoria(ongData.categoria || '');
			setAgrupacionTerminalPolitica(ongData.ref_1_agrupacion_terminal_politica || '');
			setReferentePolitico(ongData.ref_2_referente_politico || '');
			setReferenteOrganizacion(ongData.ref_3_referente_organizacion || '');
			setContacto(ongData.contacto || '');
			setLpo(ongData.lpo || '');
			setSelectedMunicipalityIds(ongData.municipios_seleccionados_ids || []);
		}
	}, [ongData]);

	// Manejador específico para el select simple
    const handleSedeChange = (e) => {
        const selectedValue = e.target.value;
		// Encontrar la opción seleccionada completa
		const selectedOption = optionsPartido.find(opt => opt.value === selectedValue) ||
			{ value: '', label: 'Seleccionar...' };
		setPartidoSede(selectedOption);

    };

	const handlePartidoSedeChange = (e) => {

		setSelectedMunicipalityIds(e.target.value);
		
		/*if (e.target.name === 'municipios_seleccionados_ids') {
			setSelectedMunicipalityIds(prev => ({
				...prev,
				[e.target.name]: e.target.value
			}));
		} else {
			// Lógica para otros inputs si los hay
			setPartidoSede(prev => ({
				...prev,
				[e.target.name]: e.target.value
			}));
		}*/
	
	};

	const handleMunicipalityChange = (e) => {
		const selectedOptions = Array.from(e.target.selectedOptions).map(
			(option) => option.value
		);
		setSelectedMunicipalityIds(selectedOptions);
	};

  const handleSubmit = async (event) => {
    event.preventDefault();

	const municipios_seleccionados_ids = selectedMunicipalityIds.map(m => m.id);
	const municipios_seleccionados_nombres = selectedMunicipalityIds.map(m => m.label);


    const datosONG = {
      ...(ongData?.id && { id: ongData.id }), // Incluir el id solo si existe
      codigo,
      partidosede: partidoSede.value,
      partidoSedeNombre: partidoSede.label,
      nombre: ONG,
      resolucion,
      categoria,
      ref_1_agrupacion_terminal_politica: agrupacionTerminalPolitica,
      ref_2_referente_politico: referentePolitico,
      ref_3_referente_organizacion: referenteOrganizacion,
      contacto,
      lpo,
	  municipios_seleccionados_ids,
	  municipios_seleccionados_nombres			
    };

    try {
      let response;
      let mensajeExito;

      if (ongData && ongData.id) {
        // Modo edición
        response = await fetch(`/api/ongs/${ongData.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(datosONG),
        });
        mensajeExito = 'ONG actualizada exitosamente!';
      } else {
        // Modo creación
        response = await fetch('/api/ongs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(datosONG),
        });
        mensajeExito = 'ONG creada exitosamente!';
      }

      if (response.ok) {
        console.log(mensajeExito);
		toast(mensajeExito);
        const resultado = await response.json();
        setNuevaONG(resultado);

        if (onSave) {
          onSave(resultado);
        }

        //if (!ongData) {
          // Limpiar formulario solo en modo creación
          setCodigo('');
          setPartidoSede({ value: '', label: '' });
          setONG('');
          setResolucion('');
          setCategoria('');
          setAgrupacionTerminalPolitica('');
          setReferentePolitico('');
          setReferenteOrganizacion('');
          setContacto('');
          setLpo('');
        //}
      } else {
        const errorData = await response.json();
        console.error('Error al guardar la ONG:', errorData);
      }
    } catch (error) {
      console.error('Error de red:', error);
    }
  };

	return (
		<>
			<form onSubmit={handleSubmit} className="bg-white dark:bg-gray-900 shadow-md rounded px-8 pt-6 pb-8 mb-4">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{/* Columna Izquierda */}
					<div className="space-y-4">
						<div>
							<Label htmlFor="codigo">Código</Label>
							<Input
								id="codigo"
								type="text"
								placeholder="Código de la ONG"
								value={codigo}
								onChange={(e) => setCodigo(e.target.value)}
								required
							/>
						</div>

						<div>
							<Label htmlFor="partidoSede">Partido sede</Label>
							<Select_simple
								id="partidoSede"
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsPartido
								]}
								value={partidoSede.value} //partidoSede
								//onChange={setPartidoSede}
								onChange={handleSedeChange}
								required
							/>
						</div>

						{/*<div>
							<Label htmlFor="municipios">Municipios</Label>
							<Select_simple
								id="municipios"
								name="municipios_seleccionados_ids"
								size={4}
								multiple={true}
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsPartido
								]}
								value={selectedMunicipalityIds.map(m => m.id)} // Aquí está la clave
								onChange={handlePartidoSedeChange}
								required
							/>
						</div>*/}

						<div>
							<Label htmlFor="nombre">Nombre de la ONG</Label>
							<Input
								id="nombre"
								type="text"
								placeholder="Nombre de la ONG"
								value={ONG}
								onChange={(e) => setONG(e.target.value)}
								required
							/>
						</div>

						<div>
							<Label htmlFor="resolucion">Resolución</Label>
							<Input
								id="resolucion"
								type="text"
								placeholder="Número de resolución"
								value={resolucion}
								onChange={(e) => setResolucion(e.target.value)}
								required
							/>
						</div>

						<div>
							<Label htmlFor="categoria">Categoría</Label>
							<Select_simple
								id="categoria"
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsCategoria.map(c => ({ value: c.value, label: c.label }))
								]}
								value={categoria}
								onChange={(e) => setCategoria(e.target.value)}
								required
							/>
						</div>
					</div>

					{/* Columna Derecha */}
					<div className="space-y-4">
						<div>
							<Label htmlFor="agrupacionTerminalPolitica">Agrupación/Terminal Política</Label>
							<Input
								id="agrupacionTerminalPolitica"
								type="text"
								value={agrupacionTerminalPolitica}
								onChange={(e) => setAgrupacionTerminalPolitica(e.target.value)}
								placeholder="Ingrese la agrupación/terminal política"
							/>
						</div>

						<div>
							<Label htmlFor="referentePolitico">Referente Político</Label>
							<Input
								id="referentePolitico"
								type="text"
								value={referentePolitico}
								onChange={(e) => setReferentePolitico(e.target.value)}
								placeholder="Ingrese el referente político"
							/>
						</div>

						<div>
							<Label htmlFor="referenteOrganizacion">Referente de Organización</Label>
							<Input
								id="referenteOrganizacion"
								type="text"
								value={referenteOrganizacion}
								onChange={(e) => setReferenteOrganizacion(e.target.value)}
								placeholder="Ingrese el referente de la organización"
							/>
						</div>

						<div>
							<Label htmlFor="contacto">Contacto</Label>
							<Input
								id="contacto"
								type="text"
								value={contacto}
								onChange={(e) => setContacto(e.target.value)}
								placeholder="Ingrese información de contacto"
							/>
						</div>

						<div>
							<Label htmlFor="lpo">LPO</Label>
							<Select_simple
								id="lpo"
								options={[
									{ value: '', label: 'Seleccionar...' },
									...optionsLPO.map(l => ({ value: l.value, label: l.label }))
								]}
								value={lpo}
								onChange={(e) => setLpo(e.target.value)}
							/>
						</div>
					</div>
				</div>

				<div className="mt-6 flex justify-end space-x-4">
					<button
						type="button"
						onClick={() => {
							// Limpiar todos los campos
							setCodigo('');
							setPartidoSede({ value: '', label: '' });
							setONG('');
							setResolucion('');
							setCategoria('');
							setAgrupacionTerminalPolitica('');
							setReferentePolitico('');
							setReferenteOrganizacion('');
							setContacto('');
							setLpo('');
							// Si hay una función onCancel (para modo edición), llamarla
							if (onCancel) onCancel();
						}}
						className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
					>
						{ongData ? 'Cancelar' : 'Limpiar'}
					</button>
					<button
						type="submit"
						className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
					>
						{ongData ? 'Actualizar ONG' : 'Crear ONG'}
					</button>
				</div>
			</form>
			<ToastContainer />
		</>
	);
};

export default FormularioNuevaONG;